import { Component, effect, inject, input, untracked } from '@angular/core';
import { TableLazyLoadEvent, TableModule, TableRowSelectEvent } from 'primeng/table';
import { OpkraevningService } from '../opkraevning.service';
import { DecimalPipe } from '@angular/common';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { TranslatePipe } from '@core/pipes/translate.pipe';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';

@Component({
  selector: 'app-opkraevning-grid',
  imports: [TableModule, DecimalPipe, TableRowDirective, TranslatePipe, KeepScrollPositionDirective],
  templateUrl: './opkraevning-grid.component.html',
  styleUrl: './opkraevning-grid.component.css',
})
export class OpkraevningGridComponent {
  opkraevningsListeId = input.required<number>();

  constructor() {
    effect(() => {
      this.opkraevningService.datasource.searchParams.set({
        opkraevningsListeId: this.opkraevningsListeId(),
      });
      untracked(() => this.opkraevningService.datasource.loadData());
    });
  }

  opkraevningService = inject(OpkraevningService);
  data = this.opkraevningService.datasource.data;

  onRowSelect(e: TableRowSelectEvent) {
    this.opkraevningService.selectOpkraevningResultRow(e.data);
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.opkraevningService.datasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }
}
